import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS, SAGE_DOMAINES_OPTIONS, SAGE_DOMAINE, SAGE_TYPES_DOCUMENTS_OPTIONS, SAGE_TYPE_DOCUMENT } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';
  
export interface MibemCommandInputConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE; 
	doDomaine: number;
	doType: number;
}
  
export class MibemCommandInputModel extends DynamicInputModel {
	@serializable() readonly type: string = 'mibem_command_input';
	componentMode: COMPONENT_MODE;
	doDomaine: number;
	doType: number;
	constructor(config: MibemCommandInputConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.doDomaine = config.doDomaine;
		this.doType = config.doType;
	}

	static initModel(_component: any): MibemCommandInputModel {
		const formModel = new MibemCommandInputModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
			doDomaine: _component.DO_DOMAINE,
			doType: _component.DO_TYPE,
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
        const workflowSteps = !!_options && !!_options.workflow ? _options.workflow.WORKFLOW_STEPS.map(step => ({ ID: step.NUM_WORKFLOWSTEP, TEXT: `${step.INDEX_WORKFLOWSTEP} - ${step.TITRE}` })) : [];
		const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP })))) : [];

		return {
			ID: 'mibem_command_input',
			CODE: CODE_WORKFLOW_COMPONENT.MIBEM_COMMAND_INPUT,
			ICON: 'reader-outline',
			LABEL: 'MIBEM - chargement des commandes',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, DEFAULT_VALUE: 'COMMANDE', CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
                { ID: 'TYPE_DEFAULT_ID_BC', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type Identifiant BC', DEFAULT_VALUE: TYPE_DEFAULT_VALUE.CONSTANT, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: TYPE_DEFAULT_VALUE.CONSTANT, TEXT: 'Constante' }, 
								{ ID: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD, TEXT: 'Champ du workflow' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ 
					ID: 'DEFAULT_ID_BC', 
					CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, 
					LABEL: 'Identifiant BC par défaut', 
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_ID_BC', value: TYPE_DEFAULT_VALUE.CONSTANT }] }] 
				},
				{ 
					ID: 'DEFAULT_ID_BC_NUMWORKFLOW_STEP', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Etape workflow', 
					IS_REQUIRED: true,
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowSteps,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_ID_BC', value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }] }] 
				},
				{ 
					ID: 'DEFAULT_ID_BC_WORKFLOW_COMPONENT_ID', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Champ workflow', 
					IS_REQUIRED: true,
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'DEFAULT_ID_BC_NUMWORKFLOW_STEP', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.FILTER_DATASOURCE, params: 'NUMWORKFLOW_STEP' }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_ID_BC', value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }] }] 
				},
				{ 
					ID: 'DEFAULT_ID_BC_WORKFLOW_COMPONENT_PROPERTY', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Propriété', 
					IS_VISIBLE: false,
					CONDITIONS_VISIBILITY: { condition: 'and', rules: [
						{ field: 'DEFAULT_ID_BC_WORKFLOW_COMPONENT_ID', operator: 'eq', scope: EXPRESSION_FIELD_SCOPE.WORKFLOW_COMPONENT_METADATA, value: CODE_WORKFLOW_COMPONENT.DROPDOWN, datasource_column: 'CODE' },
						{ field: 'TYPE_DEFAULT_ID_BC', operator: 'eq', scope: EXPRESSION_FIELD_SCOPE.CONSTANT, value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }
					]},
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'DEFAULT_ID_BC_WORKFLOW_COMPONENT_ID', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.ASSIGN_WORKFLOW_COMPONENT_DATAS, params: 'DS_COLUMNS' }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
				},
			]
		};
	}
}
  
export const FAMILLE_CDF_SANGRIA_ROUGE_ID = 9;
export const FAMILLE_CDF_VIN_ROUGE_ID = 10;
export const ORDER_FAMILLES_IDS = [1, 10, 2, 9, 3, 8, 4, 12, 5, 11, 6, 15, 7, 13, 14];
export enum Enum_TypeRemise {
    GRATUITE_ARTICLE = 1,
    REMISE_TRANSPORT_GRATUITE = 2,
    REMISE_FINANCIERE = 3,
    RISTOURNE_CLIENT = 4,
    REMISE_LIBRE = 5
}
export enum Enum_BCTypeLigne {
  LIGNE = 0,
  ENTETE = 1,
  TOTAUX = 2
}

export enum Enum_AliasID {
  GROUPE = 1,
  MIB = 2,
  MIBEM = 3,
  AGENA = 4
}

enum Command_View {
  IDLE = 0,
  COMMAND_LOADING = 1,
  COMMAND_LOADED = 2,
  COMMAND_LOADING_ERROR = 3
}

export class Model_MibemCommandGridInput {
  BON_COMMANDE_ID: number;
  BON_COMMANDE_NUM: string;

  VOLUME_TOTAL_BC: number = 0;
  VOLUME_REMISE_BC: number = 0;
  POIDS_BC_MIB: number = 0;
  POIDS_BC_MIBEM: number = 0;
  POIDS_BC_AGENA: number = 0;
  POIDS_REMISE_BC: number = 0;
  POIDS_BC: number = 0;

  VOLUME_TOTAL_GRID: number = 0;
  VOLUME_REMISE_GRID: number = 0;
  POIDS_BC_MIB_GRID: number = 0;
  POIDS_BC_MIBEM_GRID: number = 0;
  POIDS_BC_AGENA_GRID: number = 0;
  POIDS_BC_REMISE_GRID: number = 0;
  POIDS_BC_GRID: number = 0;

  GRID_DATAS: { QUANTITE_COMMANDE: number, GRATUITE_COMMANDE: number, QUANTITE_CHARGEMENT: number, QUANTITE_GRATUIT: number, MOTIF_MODIFICATION: number, COMMENTAIRE: string }[];
}

export const TYPES_MODIFICATIONS = [
  {
    ID: 1,
    TEXT: 'Modification de quantité',
    MOTIFS_MODIFICATION: [
      { ID: 1, TEXT: 'Ruptures lors du chargement' },
      { ID: 2, TEXT: 'Camion trop plein' },
      { ID: 3, TEXT: 'Casse pendant chargement' },
      { ID: 4, TEXT: 'Modif de site de chargement Bassam-Koumassi' },
      { ID: 5, TEXT: 'Autres' },
    ]
  },
  {
    ID: 2,
    TEXT: 'Modification % gratuité',
    MOTIFS_MODIFICATION: [
      { ID: 6, TEXT: 'Suite à modif qté articles chargés' },
      { ID: 7, TEXT: 'Suite à annulation de camion en propre' },
      { ID: 8, TEXT: 'Suite à la modification du BC en cours de chargement' },
    ]
  },
];